import { ConfigInterface, responseInterface } from 'swr';
import { generateCRUD, useHttp } from '@Libs/http';

const newsFeedsdApi = generateCRUD('newsfeeds', (http, path) => ({
    async getListsNewsFeeds(queries) {
        const { startIndex, keyword, tags } = queries;

        const _queries = {
            ...(startIndex && { _start: startIndex }),
            ...(keyword && { _q: keyword }),
            ...(tags && { tags }),
        };

        const response = await http.get(`${path}`, {
            params: { _start: 0, _limit: 10, ..._queries },
        });

        return response.data;
    },
    
    async getFeatured() {
        const response = await http.get('/newsfeed-home-page');
        return response.data;
    },

    async getDetail(id) {
        const response = await http.get(`${path}/${id}`);
        return response.data;
    },
    
    async getRelated(queries) {
        const { startIndex, id } = queries;
        const _queries = {
            ...(startIndex && { _start: startIndex }),
        };
        const response = await http.get(`${path}/${id}/related`, { params: { _start: 0, _limit: 10, ..._queries } });
        return response.data;
    },
}));

const DISEASE_KEY = 'newsfeed';

export const getListsNewsFeeds = (
    key = DISEASE_KEY,
    queries = {},
    config?: ConfigInterface,
): responseInterface<any, any> =>
    useHttp(key, async ({ cmsHttp }) => await newsFeedsdApi(cmsHttp).getListsNewsFeeds(queries), config);

export default newsFeedsdApi;
